var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 0.899985L8.90669 2.75999C8.69335 2.97332 8.84002 3.33332 9.14002 3.33332H10.3334V7.91999C10.3334 8.58665 9.88669 9.20665 9.22669 9.31332C8.39335 9.45332 7.66669 8.80665 7.66669 7.99999V3.44665C7.66669 2.05332 6.64669 0.813319 5.26002 0.679985C3.67335 0.526652 2.33335 1.77332 2.33335 3.33332V7.99999H1.14002C0.84002 7.99999 0.693354 8.35999 0.906687 8.56665L2.76669 10.4267C2.90002 10.56 3.10669 10.56 3.24002 10.4267L5.10002 8.56665C5.30669 8.35999 5.16002 7.99999 4.86002 7.99999H3.66669V3.41332C3.66669 2.74665 4.11335 2.12665 4.77335 2.01999C5.60669 1.87999 6.33335 2.52665 6.33335 3.33332V7.88665C6.33335 9.27999 7.35335 10.52 8.74002 10.6533C10.3267 10.8067 11.6667 9.55999 11.6667 7.99999V3.33332H12.86C13.16 3.33332 13.3067 2.97332 13.0934 2.76665L11.2334 0.906652C11.1067 0.773319 10.8934 0.773319 10.7667 0.899985Z",
    fill: "#4F8CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.f0a5f198167181937bcd97cc9a0d52cf.svg";
export { ForwardRef as ReactComponent };